import { Dispatch, SetStateAction, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../App';
import { useAppSelector } from '../../../app/hooks';
import { SidebarModal } from '../../../components/common/Sidebar/Sidebar';
import { USDT, formatUSD } from '../../../helpers/helperFunctions';
import { CaptionText, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import {
  Button,
  EarningBox,
  Flexed,
  PageTitle
} from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import {
  Icon,
  IconEarningsPartner,
  IconEarningsTotal,
  IconTodayEarnings
} from '../../../styles/Icons';
import {
  Flex,
  FlexBetween,
  FlexCenter,
  FloatingButtonBackoffice
} from '../../../styles/stylesStyled';
import { NoKyc } from '../../Dashboard/NoKyc';
import { Withdraw } from '../Withdraw/Withdraw';
import { EarningsPageEnum, EarningsHistoryFilterEnum } from '../Earnings.types';
import { TopUp } from '../TopUp/TopUp';
import { TextWithTooltip } from '../../../components/common/TextWithTooltip';
import Countdown from 'react-countdown';

interface EarningsProps {
  setMobilePage: Dispatch<SetStateAction<EarningsPageEnum>>;
  withdraw: boolean;
  topUp: boolean;
  transfer: boolean;
  setTransfer: Dispatch<SetStateAction<boolean>>;
  setTopUp: Dispatch<SetStateAction<boolean>>;
  setWithdraw: Dispatch<SetStateAction<boolean>>;
  HandleChangeFilter: (filter: EarningsHistoryFilterEnum) => void;
}

export const EarningsInfo = ({
  setMobilePage,
  withdraw,
  topUp,
  setTopUp,
  setWithdraw,
  HandleChangeFilter
}: EarningsProps) => {
  const { t } = useTranslation('earnings');

  const [step, setStep] = useState(1);
  const [noKyc, setNoKyc] = useState(false);

  const { info, loading, withdrawAvailability } = useAppSelector(
    (state) => state.earnings
  );

  const handleWithdrawButton = () => {
    if (withdrawAvailability) {
      setWithdraw(true);
      setStep(1);
    } else {
      setWithdraw(true);
      setStep(9);
    }
  };

  // const handleTopUpButton = () => {
  //   setTopUp(true);
  // };

  return (
    <div>
      <FlexBetween style={{ marginBottom: 20 }}>
        <PageTitle>{t('title')}</PageTitle>

        {/* <Desktop>
          <Button w='130px' m='6px' negative onClick={handleWithdrawButton}>
            {t('withdraw')}
          </Button>
        </Desktop>
        <Mobile>
          <FloatingButtonBackoffice>
            <Flexed>
              <Button negative m='6px' onClick={handleWithdrawButton}>
                {t('withdraw')}
              </Button>
            </Flexed>
          </FloatingButtonBackoffice>
        </Mobile> */}
        <Mobile>
          <P1
            pointer
            color={color.colors.primary900}
            onClick={() => setMobilePage(EarningsPageEnum.EARNINGS_HISTORY)}>
            {t('show_history')}
          </P1>
        </Mobile>
      </FlexBetween>
      {/* <FlipMeBanner isEarnings={true} isOpen={isOpen} setIsOpen={setIsOpen} /> */}
      <FlexCenter style={{ marginBottom: 12, marginTop: 20 }}>
        <Icon color={color.colors.neutral900} mr='8'>
          <IconEarningsTotal />
        </Icon>
        <P3 color={color.colors.neutral900} bold>
          {t('total_earnings')}
        </P3>
      </FlexCenter>

      <Flexed rowSM gap='15px'>
        <EarningBox>
          <CaptionText mb='8' caps color={color.colors.neutral500}>
            {t('total_earnings')}
          </CaptionText>
          <Flexed center end='true'>
            <P2 bold mb='8' color={color.colors.neutral900}>
              {formatUSD(info?.totalEarnings?.totalEarnings)}
            </P2>
          </Flexed>
          <Flexed center end='true'>
            <FlexCenter>
              <Icon color={color.colors.secondary100}>
                <IconTodayEarnings />
              </Icon>
              <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                {info?.totalEarnings?.todayTotalEarnings}
              </CaptionText>

              <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                {t('today')}
              </CaptionText>
            </FlexCenter>
          </Flexed>
        </EarningBox>

        <EarningBox>
          <CaptionText mb='8' caps color={color.colors.neutral500}>
            {USDT} {t('balance')}
          </CaptionText>
          <Flexed center end='true'>
            <P2 bold mb='8' color={color.colors.neutral900}>
              {formatUSD(info?.totalEarnings?.availableBalance)}
            </P2>
          </Flexed>
          <Flexed center end='true'>
            <FlexCenter>
              <Icon color={color.colors.secondary100}>
                <IconTodayEarnings />
              </Icon>
              <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                {info?.totalEarnings?.todayAvailableBalance}
              </CaptionText>

              <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                {t('today')}
              </CaptionText>
            </FlexCenter>
          </Flexed>
        </EarningBox>
      </Flexed>

      <Flexed rowSM gap='15px'>
        <EarningBox>
          <TextWithTooltip
            margin='0 0 8px 0'
            tooltip='Dr Odin balance can be used to purchase any  product available in Big Hearts Back-office. If you purchase the product with Dr Odin balance, no direct bonus is paid out.'>
            <CaptionText caps color={color.colors.neutral500}>
              DR ODIN BALANCE
            </CaptionText>
          </TextWithTooltip>

          <Flexed center end='true'>
            <P2 bold mb='8' color={color.colors.neutral900}>
              {formatUSD(info?.totalEarnings?.shoppingPoints)}
            </P2>
          </Flexed>
          <Flexed center end='true'>
            <FlexCenter>
              <Icon color={color.colors.secondary100}>
                <IconTodayEarnings />
              </Icon>
              <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                {info?.totalEarnings?.todayShoppingPoints}
              </CaptionText>

              <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                {t('today')}
              </CaptionText>
            </FlexCenter>
          </Flexed>
        </EarningBox>
        {/* <EarningBox>
          <TextWithTooltip
            margin='0'
            tooltip='Loyalty points can be used to purchase any BigWhale product available in MaVie Back-office. If you purchase the BigWhale product with loyalty points, no bonuses are paid out.'>
            <CaptionText caps color={color.colors.neutral500}>
              Loyalty points
            </CaptionText>
          </TextWithTooltip>

          <CaptionText mb='8' color={color.colors.neutral500}>
            First loyalty points expire in:{' '}
            <Countdown
              date={info?.totalEarnings.nextLpExpiryDate}
              renderer={({ days, hours, minutes }) => (
                <>
                  {days}D {hours}H {minutes}M
                </>
              )}
            />
          </CaptionText>

          <div>
            <Flexed center end='true'>
              <P2 bold mb='8' color={color.colors.neutral900}>
                {formatUSD(info?.totalEarnings?.loyaltyPoints)}
              </P2>
            </Flexed>
            <Flexed center end='true'>
              <FlexCenter>
                <Icon color={color.colors.secondary100}>
                  <IconTodayEarnings />
                </Icon>
                <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                  {info?.totalEarnings?.todayLoyaltyPoints}
                </CaptionText>

                <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                  {t('today')}
                </CaptionText>
              </FlexCenter>
            </Flexed>
          </div>
        </EarningBox> */}
      </Flexed>
      {/* <Flexed rowSM gap='15px'>
        <EarningBox>
          <TextWithTooltip
            margin='0'
            tooltip='MyLife points will be used to purchase discounts inside of Travelution Application and upcoming projects in MaVie Global ecosystem.'>
            <CaptionText caps color={color.colors.neutral500}>
              My Life Points
            </CaptionText>
          </TextWithTooltip>
          <div>
            <Flexed center end='true'>
              <P2 bold mb='8' color={color.colors.neutral900}>
                {formatUSD(info?.totalEarnings?.myLifePoints)}
              </P2>
            </Flexed>
            <Flexed center end='true'>
              <FlexCenter>
                <Icon color={color.colors.secondary100}>
                  <IconTodayEarnings />
                </Icon>
                <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                  {info?.totalEarnings?.todayMyLifePoints}
                </CaptionText>

                <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                  {t('today')}
                </CaptionText>
              </FlexCenter>
            </Flexed>
          </div>
        </EarningBox>
      </Flexed> */}

      <FlexCenter style={{ marginBottom: 12 }}>
        <Icon color={color.colors.neutral900} mr='8'>
          <IconEarningsPartner />
        </Icon>
        <P3 color={color.colors.neutral900} bold>
          {t('partner_earnings')}
        </P3>
      </FlexCenter>

      <EarningBox>
        <CaptionText mb='8' caps color={color.colors.neutral500}>
          {t('direct_bonus')}
        </CaptionText>

        <FlexBetween style={{ alignItems: 'end' }}>
          <Button
            fs='11px'
            h='30px'
            maxWidth='70px'
            negative
            style={{ fontWeight: 500 }}
            onClick={() =>
              HandleChangeFilter(EarningsHistoryFilterEnum.DIRECT_BONUS)
            }>
            INFO
          </Button>
          <div>
            <Flexed center end='true'>
              <P2 bold mb='8' color={color.colors.neutral900}>
                {formatUSD(info?.partnerEarnings?.directBonusEarnings)} {USDT}
              </P2>
            </Flexed>
            <Flexed center end='true'>
              <FlexCenter>
                <Icon color={color.colors.secondary100}>
                  <IconTodayEarnings />
                </Icon>
                <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                  {info?.partnerEarnings?.todayDirectBonusEarnings}
                </CaptionText>

                <CaptionText ml='4' caps color={color.colors.secondary100} bold>
                  {t('today')}
                </CaptionText>
              </FlexCenter>
            </Flexed>
          </div>
        </FlexBetween>
      </EarningBox>

      <SidebarModal
        isOpen={withdraw}
        setOpen={setWithdraw}
        title={`${t('withdrawal')}`}
        sidebarWidth={'508px'}>
        <Withdraw step={step} setStep={setStep} setWithdraw={setWithdraw} />
      </SidebarModal>

      <SidebarModal
        isOpen={topUp}
        setOpen={setTopUp}
        title={t('top_up')}
        sidebarWidth={'508px'}>
        <TopUp setTopUp={setTopUp} />
      </SidebarModal>

      <SidebarModal
        isOpen={noKyc}
        setOpen={setNoKyc}
        title={t('verify_your_account')}
        sidebarWidth={'508px'}>
        <NoKyc />
      </SidebarModal>
    </div>
  );
};
